module.exports = __webpack_public_path__ + "img/logo-woco-wbvelsen-color.21b51a10.png";